import React, { Component } from 'react';

import Loading from './Loading';

import * as constants from '../../config/constants/AppConstants';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import CommonPreviewFileModal from '../components/CommonPreviewFileModal';

class EB03PrintContent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Action:{
                PreviewFile: {}
            },
            Datasets: {},
            loading: true
        };
        this.updateState = this.setState.bind(this);
    }

    loadDatasets = async () => {
        let { id } = this.props;
        let sets = [
            { key: "course_eb_03", filter: [{ field: "id", value: id }] },
            { key: "training_details_enterprise_eb_03_lists", filter: [{ field: 'course_eb_03_id', value: id }] },
        ];

        await Actions.loadDatasets(this.updateState, sets);

        this.setState({loading: false});
    }    

    initialize = async () => { await this.loadDatasets(); }

    componentDidMount = async () => { await this.initialize(); }

    componentDidUpdate = async () => { }    

    render = () => {

        let { Action } = this.state;

        const { id } = this.props;

        let { Datasets } = this.state;
        let ds = Datasets;

        let eb = ds?.course_eb_03 || {};
        if (eb[0]) { eb = eb[0]; }
        eb = Object.fromEntries(Object.entries(eb).map(([key, value]) => [key, util.renderText(value)]));

        let training_details_enterprise_eb_03_lists = (ds.training_details_enterprise_eb_03_lists || []).map(exp => Object.fromEntries(Object.entries(exp).map(([key, value]) => [key, util.renderText(value)])));
        
        return (
            this.state.loading ? (<Loading></Loading>)
            :
            (
            <>
                <CommonPreviewFileModal
                    Action={Action}
                    onClose={() => Actions.handleClosePreviewFile(this.updateState)}
                />            

                <div className="print-container">
                    <>
                        <div className="print-page">
                            
                            <h6 className="text-end">สำนักงานคณะกรรมการนโยบายเขตพัฒนาพิเศษภาคตะวันออก (สกพอ.)</h6>
                            <h6 className="text-end mb-4">แบบฟอร์มรายงานผลการจัดอบรม (EB-03) Version 2.3</h6>
                            <h4 className="text-center"><b>แบบรายงานผลการจัดอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</b></h4>

                            <div className="form-section">
                    
                                <p><b>1. หลักสูตร</b></p>
                            
                                <p>1.1 รหัสหลักสูตร {util.printText(eb.official_course_code)}
                                    (ตามที่ได้รับอนุมัติจาก สกพอ.) รหัสกันเงินงบประมาณ {util.printText(eb.budget_code)}
                                </p>

                                <p>1.2 ชื่อหลักสูตร {util.printText(eb.course_eb_02_name)}</p>

                                <p>1.3 สถานศึกษาผู้รับผิดชอบหลักสูตร {util.printText(eb.academy_name)}
                                    จังหวัด {util.printText(eb.academy_province_name)}
                                </p>

                                <p>1.4 ผู้ประสานงานหลักสูตรชื่อ {util.printText(eb.course_coordinator)} หน่วยงาน {util.printText(eb.coordinator_department)}</p>
                                <p className="ms-4">อีเมล์ {util.printText(eb.coordinator_email)} โทรศัพท์มือถือ {util.printText(eb.coordinator_contact)}</p>

                                <p>1.5 รายละเอียดการจัดอบรม</p>
                                <table className="print-table-border mt-2 mb-2">
                                    <thead>
                                        <tr>
                                            <th className="text-center text-14px" style={{ width: '5%' }}>รุ่นที่</th>  
                                            <th className="text-center text-14px" style={{ width: '25%' }}>สถานประกอบการ</th> 
                                            <th className="text-center text-14px" style={{ width: '8%' }}>จำนวน<br></br>(คน)</th>   
                                            <th className="text-center text-14px" style={{ width: '8%' }}>ระยะเวลา<br></br>(วัน)</th> 
                                            <th className="text-center text-14px" style={{ width: '8%' }}>จำนวน<br></br>ชั่วโมงที่<br></br>ใช้อบรม</th>   
                                            <th className="text-center text-14px" style={{ width: '15%' }}>วันที่อบรม</th>   
                                            <th className="text-center text-14px" style={{ width: '8%' }}>งบประมาณที่ใช้<br></br>(บาท)</th> 
                                            <th className="text-center text-14px" style={{ width: '23%' }}>ชื่อและหมายเลขโทรศัพท์<br></br>ของผู้ประสานงานของ<br></br>สถานประกอบการ</th> 
                                        </tr>
                                    </thead>

                                    <tbody>
                                    {(() => {
                                        const sortedList = [...training_details_enterprise_eb_03_lists].sort((a, b) => {
                                            if (a.model_no !== b.model_no) {
                                                return a.model_no - b.model_no; 
                                            }
                                            return a.enterprise_seq - b.enterprise_seq;
                                        });

                                        let previousModelNo = null;

                                        const total = {
                                            person_count: 0,
                                            duration_days: 0,
                                            training_hours: 0,
                                            budget: 0
                                        };

                                        const rows = sortedList.map(tdel => {
                                            const showModelNo = tdel.model_no !== previousModelNo;
                                            previousModelNo = tdel.model_no;

                                            if(showModelNo){
                                                total.person_count += Number(tdel.person_count || 0);
                                                total.duration_days += Number(tdel.duration_days || 0);
                                                total.training_hours += Number(tdel.training_hours || 0);
                                                total.budget += Number(tdel.budget || 0);
                                            }

                                            return (
                                                <tr key={tdel.id}>
                                                    <td className="text-center text-14px align-top">
                                                        {showModelNo ? tdel.model_no : ''}
                                                    </td>
                                                    <td className="text-14px align-top" style={{ fontSize: '0.8rem' }}>
                                                        {tdel.enterprise_name}
                                                    </td>
                                                    <td className="text-center text-14px align-top">
                                                         {showModelNo ? util.formatNumber(tdel.person_count) : ''}
                                                    </td>
                                                    <td className="text-center text-14px align-top">
                                                         {showModelNo ? tdel.duration_days : '' }
                                                    </td>
                                                    <td className="text-center text-14px align-top">
                                                         {showModelNo ? tdel.training_hours : ''}
                                                    </td>
                                                    <td className="text-center text-14px align-top">
                                                        {showModelNo ? (
                                                        (() => {
                                                            let { training_start_date, training_end_date } = tdel;

                                                            if (util.isEmpty(training_end_date)) {
                                                            training_end_date = training_start_date;
                                                            }

                                                            training_start_date = util.convertDateToBE(training_start_date);
                                                            training_end_date = util.convertDateToBE(training_end_date);

                                                            const start = util.parseDate(training_start_date);
                                                            const end = util.parseDate(training_end_date);

                                                            return util.displayDateRange(start, end);
                                                        })()
                                                        ) : ''}
                                                    </td>
                                                    <td className="text-end text-14px align-top">
                                                        {showModelNo ? util.formatNumber(tdel.budget) : '' }
                                                    </td>
                                                    <td className="text-14px align-top">
                                                        {tdel.coordinator_name}
                                                        {tdel.coordinator_name && tdel.coordinator_phone_number && ' / '}
                                                        {tdel.coordinator_phone_number}                                                    
                                                    </td>
                                                </tr>
                                            );
                                        });

                                        return (
                                            <>
                                                {rows}
                                                <tr>
                                                    <td></td>
                                                    <td className="text-center text-14px"><b>รวม</b></td>
                                                    <td className="text-center text-14px">{util.formatNumber(total.person_count)}</td>
                                                    <td className="text-center text-14px">{total.duration_days}</td>
                                                    <td className="text-center text-14px">{total.training_hours}</td>
                                                    <td></td>
                                                    <td className="text-end text-14px">{util.formatNumber(total.budget)}</td>
                                                    <td></td>
                                                </tr>
                                            </>
                                        );
                                    })()}
                                    </tbody>
                                </table>  

                                <p>1.6 จำนวนผู้เข้ารับการอบรมรวม {util.formatNumber(eb.trainee_amount)} คน  ( แนบ รายชื่อ-ตำแหน่ง-บริษัท EB-04)
                                    {eb.trainee && (
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.trainee})}
                                        >
                                            {eb.trainee_file_name}
                                        </span>
                                    )}                                                      
                                </p> 

                                <p>1.7 จำนวนวิทยากรรวม {util.formatNumber(eb.lecturer_amount)} คน (แนบ รายชื่อ-ประวัติ CV)  
                                    {eb.lecturer && (                                                                                              
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.lecturer})}
                                        >
                                            {eb.lecturer_file_name}
                                        </span>  
                                    )}                                  
                                </p> 

                                <p className="mt-2"><b>2. หมวดค่าใช้จ่าย</b></p>
                            
                                <p>2.1 ค่าใช้จ่ายตามจริง รวม {util.printText(util.formatNumber(eb.actual_expenses_total))} บาท คิดเป็นร้อยละ 100</p>  

                                <p>2.2 ค่าลงทะเบียน/ค่าใช้จ่ายที่ได้รับจากสถานประกอบการ {util.printText(util.formatNumber(eb.registration_fee_employer_expenses))} บาท คิดเป็นร้อยละ {util.printText(util.formatNumber((100/Number(eb.actual_expenses_total)) * Number(eb.registration_fee_employer_expenses)))}</p>     

                                <p>2.3 ขอรับเงินสนับสนุนจาก สกพอ. (ไม่เกินร้อยละ 50) {util.printText(util.formatNumber(eb.eec_request_support_budget))} บาท คิดเป็นร้อยละ {util.printText(util.formatNumber((100/Number(eb.actual_expenses_total)) * Number(eb.eec_request_support_budget)))}</p>                                                                                                
                                                         
                            </div>
                        
                        </div>

                        <div className="print-page">

                            <div className="form-section">

                                <p className="mt-2"><b>3. การเบิกจ่ายเงินสนับสนุน</b></p>
                            
                                <p>3.1 ขอรับเงินสนับสนุน {eb.eec_pay_support_budget} จำนวน {util.printText(util.numberToThaiText((eb.eec_pay_support_budget)))}</p>  
                                
                                <p>3.2 ชื่อ/หน่วยงาน ผู้รับรับเงิน {util.printText(eb.receiver)}</p>
                                <div className="ms-4">ที่อยู่ {util.printText(eb.address)}</div>
                                <div className="ms-4">หมายเลขประจำตัวผู้เสียภาษี {util.printText(eb.tax_id)}</div>

                                <p>3.3 ชื่อบัญชี {util.printText(eb.account_name)} หมายเลขบัญชี {util.printText(eb.account_number)}</p>  

                                <p>3.4 ธนาคาร {util.printText(eb.bank)} สาขา {util.printText(eb.branch)}</p>  
                               
                                 <p className="mt-2"><b>4. เอกสารแนบ (กรุณาแนบตามลำดับเอกสาร)</b></p>

                                <p>4.1 หน้ารายงานต่อประธาน EEC HDC (ตาม template)  
                                    {eb.report_eec_hdc_doc && (                                                                                              
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.report_eec_hdc_doc})}
                                        >
                                            {eb.report_eec_hdc_doc_file_name}
                                        </span>
                                    )}
                                </p>    

                                <p>4.2 สำเนาเอกสารอนุมัติจัดอบรมจาก EEC HDC / สกพอ. (EB-02) 
                                    {eb.eb_02_doc && (                                                                                    
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.eb_02_doc})}
                                        >
                                            {eb.eb_02_doc_file_name}
                                        </span>
                                    )}
                                </p>   

                                <p>4.3 รายงานผลสัมฤทธิ์การอบรมและผลสอบ pre/post test   
                                    {eb.training_result_doc && (                                                                                  
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.training_result_doc})}
                                        >
                                            {eb.training_result_doc_file_name}
                                        </span>
                                    )}
                                </p>    

                                <p>
                                    4.4 รายงานบัญชีรับ - จ่าย เพื่อแสดงรายละเอียดการเบิกจ่ายเงิน
                                    {eb.income_expense_doc && (                                                                                  
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.income_expense_doc})}
                                        >
                                            {eb.income_expense_doc_file_name}
                                        </span>
                                    )}
                                </p>    
                                <p className="ms-4">(สามารถใช้แบบฟอร์มของหน่วยงานจัดอบรมได้)</p>      

                                <p>4.5 หลักฐานการชำระเงินจากสถานประกอบการที่เข้ารับการอบรม  
                                    {eb.payslip_doc && (                                                                                  
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.payslip_doc})}
                                        >
                                            {eb.payslip_doc_file_name}
                                        </span>
                                    )}
                                </p> 

                                <p>4.6 เอกสารรับรองจากสถานประกอบการที่เข้ารับการอบรม (EB-04) 
                                    {eb.eb_04_doc && (                                                                                  
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.eb_04_doc})}
                                        >
                                            {eb.eb_04_doc_file_name}
                                        </span>
                                    )}
                                </p>   

                                <p>4.7 รูปถ่ายบรรยากาศการฝึกอบรมจำนวนไม่ต่ำกว่า 4 รูป
                                    {eb.photo_doc && (                                                                                  
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.photo_doc})}
                                        >
                                            {eb.photo_doc_file_name}
                                        </span>
                                    )}
                                </p>  

                                <p>4.8 ประวัติวิทยากร
                                    {eb.lecturer_profile_doc && (                                                                                  
                                        <span className="ms-2 mb-0 text-primary text-14px underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => Actions.handlePreviewFile(this.updateState, {id: eb.lecturer_profile_doc})}
                                        >
                                            {eb.lecturer_profile_doc_file_name}
                                        </span>
                                    )}
                                </p>       

                                <p className="mt-4 ms-4">ข้าพเจ้าฯ ขอรับรองว่าข้อความและเอกสารข้างต้นเป็นความจริงทุกประการ</p>    

                                <div className="signature-grid-accurate mt-2 mb-4">
                                    <div className="signature-box"></div>
                                    <div className="signature-box">
                                        <p className="text-center" style={{minHeight: '80px'}}>{util.printText('     ')}</p>
                                        <p className="text-center">( {util.printText(eb.fullname)} )</p>
                                        <p className="text-center">ตำแหน่ง {util.printText(eb.position)}</p>
                                        <p className="text-center">วัน/เดือน/ปี พ.ศ. {util.printText(util.convertDateToTextBE(eb.form_date))}</p>                                        
                                    </div>
                                </div>                                                                                                                                                                                                              

                            </div>

                        </div>
                    </>
                </div>            
            </>

            )
        )
    }

}

export default EB03PrintContent;